module.exports = __webpack_public_path__ + "media/images/menu/icn-login-bbda569d6fca64d650765884115c5dbc.svg";